module.exports = __webpack_public_path__ + "images/beep.41925e0f21079e77635f7d515a447302.mp3";